// init store
const initState = {
  count: 0,
  login: false,
  drawerActive: false,
  modalActive: false,
  loadingRSSFeed: true,
  listRSSwwwid: [],
  modalTitle: "Default Modal Title",
  modalContent: "Default modal content is here, because didn't pass `content` argument"
};

export default initState;



// WEBPACK FOOTER //
// ./store/initState.js